import script from "./ChatFavouritePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatFavouritePanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatFavouritePanel.vue?vue&type=style&index=0&id=13f15faa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f15faa"]])

export default __exports__